export const PermissionCodes = {
  adminAccess: 'admin.access',
  contactsRead: 'contacts.read',
  contactsCreate: 'contacts.create',
  contactsUpdate: 'contacts.update',
  contactsDelete: 'contacts.delete',
  assetsRead: 'assets.read',
  assetsCreate: 'assets.create',
  assetsUpdate: 'assets.update',
  assetsDelete: 'assets.delete',
  productsRead: 'products.read',
  productsCreate: 'products.create',
  productsUpdate: 'products.update',
  productsDelete: 'products.delete',
  servicesRead: 'services.read',
  servicesCreate: 'services.create',
  servicesUpdate: 'services.update',
  servicesDelete: 'services.delete',
  invoicesRead: 'invoices.read',
  invoicesCreate: 'invoices.create',
  invoicesUpdate: 'invoices.update',
  invoicesDelete: 'invoices.delete',
  calendarRead: 'calendar.read',
  calendarManage: 'calendar.manage',
  calendarStatusesManage: 'calendar.statuses.manage',
  rosteringRead: 'rostering.read',
  rosteringManage: 'rostering.manage',
  rosteringManageAll: 'rostering.manage-all',
  fieldOperationsCheckIn: 'field-operations.check-in',
  fieldOperationsRead: 'field-operations.read',
  fieldOperationsSettings: 'field-operations.settings',
  consultationsRead: 'consultations.read',
  consultationsManage: 'consultations.manage',
  consultationsDelete: 'consultations.delete',
  consultationsFieldAssignmentsManage: 'consultations.field-assignments.manage',
  companiesRead: 'companies.read',
  companiesManage: 'companies.manage',
  companiesCompanyManage: 'companies.company.manage',
  companiesDepartmentsManage: 'companies.departments.manage',
  companiesPositionsManage: 'companies.positions.manage',
  companiesLocationsManage: 'companies.locations.manage',
  companiesRoomsManage: 'companies.rooms.manage',
  companiesBusinessHoursManage: 'companies.business-hours.manage',
  companiesChatbotBlockoutsManage: 'companies.chatbot-blockouts.manage',
  companiesAssistantManage: 'companies.assistant.manage',
  connectorsRead: 'connectors.read',
  connectorsManage: 'connectors.manage',
  accountLimitsRead: 'account-limits.read',
  accountLimitsManage: 'account-limits.manage',
  conversationsRead: 'conversations.read',
  conversationsReply: 'conversations.reply',
  conversationsAssign: 'conversations.assign',
  conversationsManage: 'conversations.manage',
  callsReadAll: 'calls.read-all',
  messageTemplatesRead: 'messages.templates.read',
  messageTemplatesManage: 'messages.templates.manage',
  employeesRead: 'employees.read',
  employeesManage: 'employees.manage',
  tasksRead: 'tasks.read',
  tasksManage: 'tasks.manage',
  knowledgeRead: 'knowledge.read',
  knowledgeManage: 'knowledge.manage',
  aiConfigRead: 'ai.config.read',
  aiConfigManage: 'ai.config.manage',
  aiOrchestratorsRead: 'ai.orchestrators.read',
  aiOrchestratorsManage: 'ai.orchestrators.manage',
  apiToolsRead: 'ai.api-tools.read',
  apiToolsManage: 'ai.api-tools.manage',
  mcpConnectorsRead: 'ai.mcp.read',
  mcpConnectorsManage: 'ai.mcp.manage',
  aiToolPluginsRead: 'ai.tool-plugins.read',
  aiToolPluginsManage: 'ai.tool-plugins.manage',
  aiTokenUsageRead: 'ai.token-usage.read',
  remindersRead: 'reminders.read',
  remindersManage: 'reminders.manage',
  rolesRead: 'roles.read',
  rolesManage: 'roles.manage',
  rolesAssign: 'roles.assign',
} as const;

export const PermissionScopes = {
  contactsRead: [
    PermissionCodes.contactsRead,
    PermissionCodes.contactsCreate,
    PermissionCodes.contactsUpdate,
    PermissionCodes.contactsDelete,
  ],
  contactsCreate: [
    PermissionCodes.contactsCreate,
  ],
  assetsRead: [
    PermissionCodes.assetsRead,
    PermissionCodes.assetsCreate,
    PermissionCodes.assetsUpdate,
    PermissionCodes.assetsDelete,
  ],
  assetsCreate: [
    PermissionCodes.assetsCreate,
  ],
  assetsUpdate: [
    PermissionCodes.assetsUpdate,
  ],
  assetsDelete: [
    PermissionCodes.assetsDelete,
  ],
  productsRead: [
    PermissionCodes.productsRead,
    PermissionCodes.productsCreate,
    PermissionCodes.productsUpdate,
    PermissionCodes.productsDelete,
  ],
  productsCreate: [
    PermissionCodes.productsCreate,
  ],
  productsUpdate: [
    PermissionCodes.productsUpdate,
  ],
  productsDelete: [
    PermissionCodes.productsDelete,
  ],
  servicesRead: [
    PermissionCodes.servicesRead,
    PermissionCodes.servicesCreate,
    PermissionCodes.servicesUpdate,
    PermissionCodes.servicesDelete,
  ],
  servicesCreate: [
    PermissionCodes.servicesCreate,
  ],
  servicesUpdate: [
    PermissionCodes.servicesUpdate,
  ],
  servicesDelete: [
    PermissionCodes.servicesDelete,
  ],
  invoicesRead: [
    PermissionCodes.invoicesRead,
    PermissionCodes.invoicesCreate,
    PermissionCodes.invoicesUpdate,
    PermissionCodes.invoicesDelete,
  ],
  invoicesCreate: [
    PermissionCodes.invoicesCreate,
  ],
  invoicesUpdate: [
    PermissionCodes.invoicesUpdate,
  ],
  invoicesDelete: [
    PermissionCodes.invoicesDelete,
  ],
  calendarRead: [
    PermissionCodes.calendarRead,
    PermissionCodes.calendarManage,
  ],
  calendarStatusesManage: [
    PermissionCodes.calendarStatusesManage,
  ],
  rosteringRead: [
    PermissionCodes.rosteringRead,
    PermissionCodes.rosteringManage,
    PermissionCodes.rosteringManageAll,
  ],
  rosteringManage: [
    PermissionCodes.rosteringManage,
    PermissionCodes.rosteringManageAll,
  ],
  rosteringManageAll: [
    PermissionCodes.rosteringManageAll,
  ],
  fieldOperationsCheckIn: [
    PermissionCodes.fieldOperationsCheckIn,
    PermissionCodes.fieldOperationsRead,
  ],
  fieldOperationsRead: [
    PermissionCodes.fieldOperationsRead,
  ],
  fieldOperationsSettings: [
    PermissionCodes.fieldOperationsSettings,
  ],
  consultationsRead: [
    PermissionCodes.consultationsRead,
    PermissionCodes.consultationsManage,
  ],
  consultationsManage: [
    PermissionCodes.consultationsManage,
  ],
  consultationsDelete: [
    PermissionCodes.consultationsDelete,
    PermissionCodes.consultationsManage,
  ],
  consultationsFieldAssignmentsManage: [
    PermissionCodes.consultationsFieldAssignmentsManage,
    PermissionCodes.consultationsManage,
  ],
  companiesRead: [
    PermissionCodes.companiesRead,
    PermissionCodes.companiesManage,
    PermissionCodes.companiesCompanyManage,
    PermissionCodes.companiesDepartmentsManage,
    PermissionCodes.companiesPositionsManage,
    PermissionCodes.companiesLocationsManage,
    PermissionCodes.companiesRoomsManage,
    PermissionCodes.companiesBusinessHoursManage,
    PermissionCodes.companiesChatbotBlockoutsManage,
    PermissionCodes.companiesAssistantManage,
  ],
  companiesManage: [
    PermissionCodes.companiesManage,
  ],
  companiesCompanyManage: [
    PermissionCodes.companiesCompanyManage,
    PermissionCodes.companiesManage,
  ],
  companiesDepartmentsManage: [
    PermissionCodes.companiesDepartmentsManage,
    PermissionCodes.companiesManage,
  ],
  companiesPositionsManage: [
    PermissionCodes.companiesPositionsManage,
    PermissionCodes.companiesManage,
  ],
  companiesLocationsManage: [
    PermissionCodes.companiesLocationsManage,
    PermissionCodes.companiesManage,
  ],
  companiesRoomsManage: [
    PermissionCodes.companiesRoomsManage,
    PermissionCodes.companiesManage,
  ],
  companiesBusinessHoursManage: [
    PermissionCodes.companiesBusinessHoursManage,
    PermissionCodes.companiesManage,
  ],
  companiesChatbotBlockoutsManage: [
    PermissionCodes.companiesChatbotBlockoutsManage,
    PermissionCodes.companiesManage,
  ],
  companiesAssistantManage: [
    PermissionCodes.companiesAssistantManage,
    PermissionCodes.companiesManage,
    PermissionCodes.adminAccess,
  ],
  connectorsRead: [
    PermissionCodes.connectorsRead,
    PermissionCodes.connectorsManage,
    PermissionCodes.adminAccess,
  ],
  connectorsManage: [
    PermissionCodes.connectorsManage,
    PermissionCodes.adminAccess,
  ],
  accountLimitsRead: [
    PermissionCodes.accountLimitsRead,
    PermissionCodes.accountLimitsManage,
    PermissionCodes.adminAccess,
  ],
  accountLimitsManage: [
    PermissionCodes.accountLimitsManage,
    PermissionCodes.adminAccess,
  ],
  conversationsRead: [
    PermissionCodes.conversationsRead,
    PermissionCodes.conversationsReply,
    PermissionCodes.conversationsAssign,
    PermissionCodes.conversationsManage,
  ],
  conversationsReply: [
    PermissionCodes.conversationsReply,
    PermissionCodes.conversationsManage,
  ],
  callsReadAll: [
    PermissionCodes.callsReadAll,
    PermissionCodes.conversationsManage,
  ],
  employeesRead: [
    PermissionCodes.employeesRead,
    PermissionCodes.employeesManage,
  ],
  tasksRead: [
    PermissionCodes.tasksRead,
    PermissionCodes.tasksManage,
  ],
  knowledgeRead: [
    PermissionCodes.knowledgeRead,
    PermissionCodes.knowledgeManage,
  ],
  aiConfigRead: [
    PermissionCodes.aiConfigRead,
    PermissionCodes.aiConfigManage,
    PermissionCodes.knowledgeRead,
    PermissionCodes.knowledgeManage,
  ],
  aiOrchestratorsRead: [
    PermissionCodes.aiOrchestratorsRead,
    PermissionCodes.aiOrchestratorsManage,
    PermissionCodes.aiConfigRead,
    PermissionCodes.aiConfigManage,
  ],
  aiOrchestratorsManage: [
    PermissionCodes.aiOrchestratorsManage,
    PermissionCodes.aiConfigManage,
  ],
  apiToolsRead: [
    PermissionCodes.apiToolsRead,
    PermissionCodes.apiToolsManage,
    PermissionCodes.aiConfigRead,
    PermissionCodes.aiConfigManage,
  ],
  apiToolsManage: [
    PermissionCodes.apiToolsManage,
    PermissionCodes.aiConfigManage,
  ],
  mcpConnectorsRead: [
    PermissionCodes.mcpConnectorsRead,
    PermissionCodes.mcpConnectorsManage,
    PermissionCodes.aiConfigRead,
    PermissionCodes.aiConfigManage,
  ],
  mcpConnectorsManage: [
    PermissionCodes.mcpConnectorsManage,
    PermissionCodes.aiConfigManage,
  ],
  aiToolPluginsRead: [
    PermissionCodes.aiToolPluginsRead,
    PermissionCodes.aiToolPluginsManage,
    PermissionCodes.aiConfigRead,
    PermissionCodes.aiConfigManage,
  ],
  aiToolPluginsManage: [
    PermissionCodes.aiToolPluginsManage,
    PermissionCodes.aiConfigManage,
  ],
  aiTokenUsageRead: [
    PermissionCodes.aiTokenUsageRead,
    PermissionCodes.adminAccess,
  ],
  remindersRead: [
    PermissionCodes.remindersRead,
    PermissionCodes.remindersManage,
  ],
  remindersManage: [
    PermissionCodes.remindersManage,
  ],
  rolesRead: [
    PermissionCodes.rolesRead,
    PermissionCodes.rolesManage,
  ],
} as const;
